// Variable overrides
